import { createAsyncThunk } from "@reduxjs/toolkit";
import { getAccessAuthorizationHeaders } from "../../../../api";
import { helpers } from "../../../../packages/helpers";
import { selectChatId } from "../../selectors";
import { CHAT_ACTIONS, PostMessageFileData } from "../../types";
import type { ActionStoreParams } from "../../../../store";
import type {
  PostMessageFileApiCallback,
  PostMessageResponse,
} from "../../types";

const { getActionErrorText } = helpers.error;
const { getStringValue } = helpers.text;

type ActionParams = {
  postMessageFileApi: PostMessageFileApiCallback;
  message: PostMessageFileData;
  traceId: string;
};

type ActionReturn = {
  messageId: string;
};

export const postMessageFile = createAsyncThunk<
  ActionReturn,
  ActionParams,
  ActionStoreParams
>(
  CHAT_ACTIONS.POST_MESSAGE_FILE,
  async ({ message, postMessageFileApi }, { getState }) => {
    try {
      const chatId = selectChatId(getState());
      const headers = getAccessAuthorizationHeaders(getState());
      // TODO разобраться с "as PostMessageResponse"
      const resp = (await postMessageFileApi(chatId, message, {
        headers,
      })) as PostMessageResponse;

      const messageId = getStringValue(resp?.data?.id);

      return { messageId };
    } catch (e) {
      const text = getActionErrorText(e);

      throw new Error(text);
    }
  }
);
